import React from "react";
import { Spinner } from "react-bootstrap";

interface LoadingProps {
    children?: () => JSX.Element;
    isLoading?: boolean;
}

const Loading: React.FC<LoadingProps> = (props) => {

    if (props.children == null || props.isLoading) return <Spinner animation={"border"} />

    return props.children();
}

export default Loading;